import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import styled, { css } from 'styled-components';
const Pagination = styled.div `
  display: flex;
  width: max-content;
  max-width: 100%;
  align-items: center;

  small {
    display: block;
    width: 100%;
    font-size: 18px;
    ${fonts.DaxPro['Regular']};
    padding-right: 15px;
  }
`;
const ArrowButton = styled.button.attrs({ type: 'button' }) `
  ${ButtonReset};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background-color: ${brand.primary.base};
  color: ${brand.white};

  min-width: 45px;
  min-height: 45px;

  ${({ direction }) => {
    switch (direction) {
        case 'left':
            return css `
          margin-right: 6px;

          svg {
            transform: rotate(180deg);
          }
        `;
        case 'right':
            return css ``;
        default:
            break;
    }
}}

  ${({ disabled }) => disabled &&
    css `
      opacity: 0.5;

      &:hover {
        background-color: ${brand.primary.base};
      }
    `}

    svg {
    width: 13px;
  }
`;
export const ButtonPaginationStyles = {
    ArrowButton,
    Pagination,
};
